module.exports = __webpack_public_path__ + "static/img/icon_locate@2x.553ca072.png";